// export default Information;
import { useEffect } from "react";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import MKAlert from "components/MKAlert";

function FormInformationSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const props = location.state;
  useEffect(() => {
    if (props === null) {
      navigate("/ndrs/consent");
    }
  }, []);
  const [isShowCondition, setIsShowCondition] = React.useState(false);
  const [checked, setChecked] = React.useState(false);
  const [isAlert, setIsAlert] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("");
  const [alertType, setAlertType] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const handleCloseDialog = () => {
    setOpen(false);
  };
  const handleAcceptConditions = async (e) => {
    setIsLoading(true);
    if (checked) {
      //dowload pdf and alert success
      e.preventDefault();
      try {
        const pdfUrl = `${process.env.PUBLIC_URL}/contract.pdf`;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = "contract.pdf"; // Optional: Rename the file upon download
        link.click();
        setIsLoading(false);
        setOpen(true);
      } catch (error) {
        setIsLoading(false);
        setIsAlert(true);
        setAlertMsg("ไม่สามารถดาวน์โหลดสัญญาข้อตกลงและเงื่อนไขมาตรการช่วยเหลือของธนาคารได้");
        setAlertType("error");
        console.error("Error downloading PDF:", error);
      }
    } else {
      setIsLoading(false);
      setIsAlert(true);
      setAlertMsg("กรุณายอมรับข้อตกลงและเงื่อนไขมาตรการช่วยเหลือของธนาคาร");
      setAlertType("warning");
    }
  };

  return (
    <MKBox component="section" py={{ xs: 6, sm: 12 }}>
      <Container>
        {isAlert ? (
          <>
            <MKAlert color={alertType} dismissible>
              {alertMsg}
            </MKAlert>
            <br />
          </>
        ) : null}
        {!isShowCondition ? (
          <Grid container item xs={12} justifyContent="center">
            <Grid container justifyContent="center" py={2} spacing={1} sx={{ textAlign: "center" }}>
              <MKTypography variant="subtitle2" fontWeight="medium" color="primary">
                ลงทะเบียนสำเร็จ
                <br />
                ท่านได้รับสิทธิ์ {props.debtRepaymentDesc}
              </MKTypography>
            </Grid>
            <Grid container justifyContent="center" py={2} spacing={1} sx={{ textAlign: "center" }}>
              <MKTypography variant="subtitle2" fontWeight="medium" color="dark">
                ปรับปรุงโครงสร้างหนี้ด้วยการลดภาระการชำระหนี้บัญชีที่มีภาระหนี้เงินต้นและดอกเบี้ยไม่เกิน
                1 แสนบาท
                <br />
                ธนาคารลดภาระหนี้เงินต้นบางส่วน ดอกเบี้ยค้างชำระ ค่าธรรมเนียม และค่าใช้จ่ายทั้งหมด
                <br />
                โดยลูกค้าชำระหนี้ส่วนที่เหลือเพื่อปิดบัญชี
                ภายในสองเดือนนับตั้งแต่วันที่ยืนยันแจ้งความประสงค์
                <br />
                เงื่อนไขอื่นตามที่ธนาคารกำหนด
              </MKTypography>
            </Grid>
            <Grid
              container
              justifyContent="center"
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              sx={{ textAlign: "center" }}
            >
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <MKTypography variant="subtitle2" fontWeight="medium" color="dark">
                  เลขที่บัญชีสินเชื่อ
                </MKTypography>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <MKTypography variant="subtitle2" fontWeight="medium" color="dark">
                  {props.accountNo}
                </MKTypography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              sx={{ textAlign: "center" }}
            >
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <MKTypography variant="subtitle2" fontWeight="medium" color="dark">
                  เงื่อนไข
                </MKTypography>
              </Grid>
              <Grid item xs={12} sm={12} md={4} lg={4}>
                <MKTypography variant="subtitle2" fontWeight="regular" color="dark">
                  สอบถามยอดชำระกับสาขาที่ท่านยื่นกู้
                </MKTypography>
              </Grid>
            </Grid>

            <Grid container justifyContent="center" py={2} spacing={1} sx={{ textAlign: "center" }}>
              <MKTypography variant="subtitle2" fontWeight="regular" color="dark">
                **ธนาคารจะดำเนินการปิดบัญชีภายใน 4 วัน หลังจากที่ท่านชำระเงินครบตามเงื่อนไข
              </MKTypography>
            </Grid>

            <Grid container justifyContent="center" py={2}>
              <MKButton
                variant="contained"
                color="primary"
                onClick={() => setIsShowCondition(true)}
              >
                ยืนยันการลงทะเบียน
              </MKButton>
            </Grid>
          </Grid>
        ) : (
          <Grid container item xs={12} justifyContent="center" mx="auto">
            <MKTypography variant="h4" fontWeight="medium" color="primary">
              ข้อตกลงและเงื่อนไขมาตรการช่วยเหลือของธนาคาร
            </MKTypography>
            <Grid container justifyContent="center" py={2}>
              <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                <MKTypography variant="body2" fontWeight="regular" color="dark">
                  1. ข้าพเจ้าตกลงยอมรับว่า แผนการชำระหนี้ที่ข้าพเจ้าเลือกไว้ข้างต้นและการกด “ยอมรับ”
                  ด้านล่างนี้ เป็นการแสดงความประสงค์ของข้าพเจ้าที่จะขอเข้ามาตรการช่วยเหลือของธนาคาร
                  เพื่อขอเปลี่ยนแปลงเงื่อนไขการชำระหนี้ตามสัญญากู้เงิน/สัญญาปรับปรุงโครงสร้างหนี้/คำพิพากษา/หนังสือขอผ่อนผันการชำระหนี้หลังคำพิพากษาที่ปรากฏบน
                  Website ธนาคาร หรือระบบงาน MyMo <br />
                  2. ข้าพเจ้าตกลงผูกพันและปฏิบัติตามแผนการชำระหนี้ที่ข้าพเจ้าได้เลือกไว้ทุกประการ
                  และตกลงยอมรับว่าข้าพเจ้ามีหน้าที่ชำระหนี้ดังกล่าวตามจำนวนงวดและจำนวนเงินงวดในแต่ละงวดทั้งหมดที่ปรากฏในขั้นตอนการเลือกแผนการชำระหนี้บน
                  Website ธนาคาร หรือระบบงาน MyMo โดยตกลงชำระหนี้งวดแรกในเดือน - พ.ศ. -
                  และตกลงชำระหนี้ให้เสร็จสิ้นภายในสองเดือนนับตั้งแต่วันที่ยืนยันแจ้งความประสงค์
                  <br />
                  ทั้งนี้ ข้าพเจ้ารับทราบว่า จำนวนเงินงวดที่ปรากฏในขั้นตอนการเลือกแผนการชำระหนี้บน
                  Website ธนาคาร หรือระบบงาน MyMo ดังกล่าวข้างต้นมีเฉพาะจำนวนเงินต้น
                  เนื่องจากการเข้าร่วมมาตรการช่วยเหลือของธนาคารในครั้งนี้
                  ธนาคารตกลงยกเว้นดอกเบี้ยของเงินต้นในระหว่างมาตรการให้กับข้าพเจ้า
                  <br />
                  3.
                  กรณีที่ธนาคารยินยอมให้มีการขยายระยะเวลาของสัญญากู้เงิน/สัญญาปรับปรุงโครงสร้างหนี้
                  ข้าพเจ้าตกลงชำระหนี้ค้างชำระให้เสร็จสิ้น
                  ภายในกำหนดชำระหนี้งวดเดือนสุดท้ายที่ปรากฏในข้อ 2. ของข้อตกลงฉบับนี้
                  <br />
                  4.
                  กรณีที่ข้าพเจ้าได้แจ้งความประสงค์ให้ธนาคารหักหรือถอนเงินจากบัญชีเงินฝากเพื่อการชำระหนี้แต่ละงวดไว้
                  ข้าพเจ้าตกลงดำรงเงินฝากในบัญชีเงินฝากทุกขณะให้มีจำนวนเงินไม่น้อยกว่าจำนวนเงินงวดที่ข้าพเจ้าต้องชำระให้แก่ธนาคารทั้งหมดในแต่ละงวด
                  และหากเงินในบัญชีดังกล่าวของข้าพเจ้ามีไม่เพียงพอต่อการหักชำระหนี้ไม่ว่างวดหนึ่งงวดใด
                  ให้ถือว่าข้าพเจ้าผิดนัดผิดสัญญากับธนาคาร
                  และธนาคารมีสิทธินำส่งรายงานข้อมูลเครดิตของข้าพเจ้าไปยังบริษัท ข้อมูลเครดิตแห่งชาติ
                  จำกัด ตามที่กฎหมายกำหนด และมีสิทธิคิดอัตราดอกเบี้ยผิดนัด
                  รวมทั้งบังคับชำระหนี้กับข้าพเจ้าได้ตามเงื่อนไขในสัญญากู้เงิน/สัญญาปรับปรุงโครงสร้างหนี้
                  และตามขั้นตอนของกฎหมาย
                  <br />
                  5.
                  เมื่อข้าพเจ้าสามารถชำระหนี้เงินต้นได้ครบถ้วนเต็มตามจำนวนที่กำหนดในแผนการชำระหนี้บน
                  Website ธนาคาร หรือระบบงาน MyMo และภายในระยะเวลาที่กำหนดในข้อ 2.
                  ข้าพเจ้าตกลงรับทราบว่า ธนาคารจะยกเว้นภาระหนี้ส่วนที่เหลือให้แก่ข้าพเจ้าทั้งจำนวน
                  <br />
                  6.
                  กรณีที่ข้าพเจ้าชำระหนี้เกินกว่าจำนวนเงินงวดที่ปรากฏในขั้นตอนการเลือกแผนการชำระหนี้บน
                  Website ธนาคาร หรือระบบงาน MyMo
                  ข้าพเจ้าตกลงให้เป็นดุลพินิจของธนาคารในการนำเงินดังกล่าวไปจัดสรรชำระหนี้ตามที่ธนาคารเห็นสมควร
                  <br />
                  7. ข้าพเจ้าตกลงยอมรับว่า บรรดาข้อความ เอกสาร หนังสือ
                  ที่เกี่ยวข้องกับการปฏิบัติตามข้อตกลงฉบับนี้
                  ซึ่งธนาคารมีหน้าที่จะต้องแจ้งแก่ข้าพเจ้า
                  ไม่ว่าจะได้จัดทำขึ้นและแจ้งแก่ข้าพเจ้าโดยวิธีการใด
                  ซึ่งรวมถึงวิธีการทางอิเล็กทรอนิกส์ ให้ถือเป็นส่วนหนึ่งของข้อตกลงฉบับนี้
                  และให้ถือว่าข้าพเจ้าได้รับทราบแล้วโดยชอบ
                  <br />
                  8. กรณีที่ข้าพเจ้าปฏิบัติผิดเงื่อนไขของข้อตกลงฉบับนี้
                  สัญญากู้เงิน/สัญญาปรับปรุงโครงสร้างหนี้ฉบับที่เกี่ยวข้อง หรือฉบับอื่นใดกับธนาคาร
                  ไม่ว่าจะได้ทำขึ้นก่อนหรือหลังข้อตกลงฉบับนี้ก็ตาม
                  ข้าพเจ้ายินยอมให้ถือว่าข้าพเจ้าปฏิบัติผิดสัญญากับธนาคารทั้งหมด
                  และยินยอมให้ธนาคารบอกเลิกสัญญาพร้อมทั้งเรียกให้ชำระหนี้คืนทั้งหมดได้ในทันทีตามเงื่อนไขของสัญญากู้เงิน/สัญญาปรับปรุงโครงสร้างหนี้/คำพิพากษา/หนังสือขอผ่อนผันการชำระหนี้หลังคำพิพากษา
                  รวมถึงบังคับชำระหนี้ บังคับจำนอง และหรือบังคับหลักประกันที่เกี่ยวข้องได้
                  โดยข้าพเจ้ายินยอมชดใช้ค่าเสียหายกรณีผิดสัญญา ค่าใช้จ่ายในการทวงถามการดำเนินคดี
                  และการบังคับคดีทั้งหมดด้วย
                  <br />
                  บรรดาเงื่อนไขและข้อสัญญาที่กำหนดไว้ในสัญญากู้เงิน/สัญญาปรับปรุงโครงสร้างหนี้/คำพิพากษา/หนังสือ
                  ขอผ่อนผันการชำระหนี้หลังคำพิพากษา และหรือข้อตกลง
                  และหรือบันทึกและหรือเอกสารอื่นใดที่ได้จัดทำขึ้นโดยเกี่ยวข้องกับสัญญาดังกล่าว
                  ซึ่งมิได้ถูกยกเลิก แก้ไข หรือเพิ่มเติมโดยข้อตกลงฉบับนี้
                  ให้ยังคงมีผลบังคับใช้ต่อไปเท่าที่ไม่ขัดแย้งกับข้อตกลงฉบับนี้
                </MKTypography>
              </Grid>
            </Grid>
            <Grid container justifyContent="center" py={2}>
              <FormControlLabel
                control={<Checkbox color="primary" checked={checked} onChange={handleChange} />}
                label="ข้าพเจ้าได้อ่านและเข้าใจข้อความข้างต้นโดยครบถ้วนแล้ว เห็นว่าถูกต้องตามความประสงค์ จึงได้แสดงเจตนาตกลงผูกพันตามแผนการชำระหนี้ที่ข้าพเจ้าเลือกไว้ข้างต้น รวมถึงข้อตกลงฉบับนี้ด้วยการกด “ยอมรับ” ด้านล่างนี้"
              />
            </Grid>
            <Grid container justifyContent="center" py={2}>
              <MKButton variant="contained" color="primary" onClick={handleAcceptConditions}>
                ยอมรับ
              </MKButton>
            </Grid>
            {isLoading ? (
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Stack sx={{ width: "50%" }}>
                    <LinearProgress color="primary" />
                  </Stack>
                </Grid>
              </Grid>
            ) : null}
          </Grid>
        )}
        {open ? (
          <Dialog
            open={open}
            onClose={handleCloseDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">แจ้งเตือน</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                ดาวน์โหลดสัญญาข้อตกลงและเงื่อนไขมาตรการช่วยเหลือของธนาคาร สำเร็จ
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <MKButton
                variant="contained"
                color="primary"
                onClick={() => navigate("/ndrs/consent")}
              >
                กลับหน้าหลัก
              </MKButton>
            </DialogActions>
          </Dialog>
        ) : null}
      </Container>
    </MKBox>
  );
}
FormInformationSuccess.defaultProps = {
  isCustTarget: false,
  debtRepaymentDesc: "",
  accountNo: "",
};

FormInformationSuccess.propTypes = {
  isCustTarget: PropTypes.bool,
  debtRepaymentDesc: PropTypes.string,
  accountNo: PropTypes.string,
};
export default FormInformationSuccess;
